import React, { useEffect } from "react";
import { multiFactor, getAuth, onAuthStateChanged } from "firebase/auth";
import Certificates from "./Components/certificates/Certificates";
import SignIn from "./Components/auth/SignIn";
import LogoutButton from "./Components/auth/LogoutButton";
import Details from "./Components/auth/Details";
import { getFirestore } from "firebase/firestore";
import { doc, getDoc } from "firebase/firestore";
import AdminButton from "./Components/admin/AdminButton";
import AdminBackButton from "./Components/admin/AdminBackButton";
import AdminPanel from "./Components/admin/AdminPanel";
import { roles } from "./config";
import "./config/firebase-config";
import { useSelector, useDispatch } from "react-redux";
import { setAuth, setToken, setIsAdmin, setIsOneFactor } from "./actions/auth";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

function App() {
  const db = getFirestore();

  const auth = useSelector((state) => state.auth.isAuth);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const isOneFactor = useSelector((state) => state.auth.isOneFactor);
  const dispatch = useDispatch();

  let navigate = useNavigate();

  const saveAuthState = async (userCred) => {
    const docRef = doc(db, "Users", userCred.uid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const IsUserAdmin = () => {
        return docSnap.data().role === roles.ADMIN;
      };
      dispatch(setIsAdmin(IsUserAdmin()));
      window.localStorage.setItem("isAdmin", IsUserAdmin() ? "true" : "false");
    } else {
      // doc.data() will be undefined in this case
    }

    dispatch(setAuth(true));
    window.localStorage.setItem("auth", "true");
    await userCred
      .getIdToken()
      .then((token) => {
        dispatch(setToken(token));
        window.localStorage.setItem("token", token);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, async (userCred) => {
      if (userCred) {
        const multiFactorUser = multiFactor(auth.currentUser);
        if (multiFactorUser.enrolledFactors.length === 0) {
          dispatch(setIsOneFactor(true));
        }

        await saveAuthState(userCred);
        if (multiFactorUser.enrolledFactors.length === 0) {
          navigate("/details");
        } else {
          navigate("/certificates");
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const BuildAddWrapperDiv = (props) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "right",
      }}
    >
      {props.children}
    </div>
  );

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route
          path="details"
          element={
            auth && isOneFactor ? (
              <>
                <LogoutButton />
                <Details />
              </>
            ) : (
              <Navigate replace to="/" />
            )
          }
        />
        <Route
          path="adminpanel"
          element={
            auth && isAdmin && !isOneFactor ? (
              <>
                <BuildAddWrapperDiv>
                  {<AdminBackButton />}
                  <LogoutButton />
                </BuildAddWrapperDiv>

                <AdminPanel />
              </>
            ) : (
              <Navigate replace to="/" />
            )
          }
        />
        <Route
          path="certificates"
          element={
            auth && !isOneFactor ? (
              <>
                <BuildAddWrapperDiv>
                  {isAdmin && <AdminButton />}
                  <LogoutButton />
                </BuildAddWrapperDiv>

                <Certificates />
              </>
            ) : (
              <Navigate replace to="/" />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
